//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'caidengmiRule',
  components: {
  },
  data () {
    return {
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
  },
  created () {
  }
}
